import templateUrl from "./403.component.html";
import "./error-page.less";

export const AccessDeniedComponent = {
    templateUrl
};
